import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnviromentContextService } from './services/enviroment-context-service';
import { ConfigComponent } from './config/config.component';
import { CommonAppModule } from "../common-app/common-app.module";
import { MatIconModule } from '@angular/material/icon';
import { StorageEnviromentContextService } from './services/storage-enviroment-context.service';
import { AppNameService } from './services/app-name-service';
import { ENVIROMENT_MODULE_CONFIG, EnviromentModuleConfig } from './enviroment-config';



@NgModule({
    declarations: [
        ConfigComponent
    ],
    imports: [
        CommonModule,
        CommonAppModule,
        MatIconModule
    ]
})
export class EnviromentModule { 
  static forRoot(config: EnviromentModuleConfig): ModuleWithProviders<EnviromentModule> {
    return {
      ngModule: EnviromentModule,
      providers: [
        { provide: ENVIROMENT_MODULE_CONFIG, useValue: config },
        AppNameService,
        StorageEnviromentContextService,
        { provide: EnviromentContextService, useExisting: StorageEnviromentContextService }
      ]
    };
  }
}